module.exports = __webpack_public_path__ + "static/media/13 soccer fans.dec3d9db.JPG";